import { useState } from 'react';
import { useApp, useCan } from '../../app/AppContext.js';
import { useAsync } from '../lib/useAsync.js';
import {
  Badge,
  Button,
  Card,
  ErrorBlock,
  Loading,
  PageHeader,
} from '../components/primitives.js';
import { useToast } from '../components/Toast.js';
import { IconCheck, IconGateway } from '../components/icons.js';
import type { GatewayInfo } from '../../data/port.js';

export function Gateway() {
  const { data } = useApp();
  const toast = useToast();
  const admin = useCan('console-admin');
  const [trocando, setTrocando] = useState<string | null>(null);

  const estado = useAsync<GatewayInfo>(() => data.getGateway(), [data]);

  const trocar = async (nome: string) => {
    setTrocando(nome);
    try {
      const info = await data.setGateway(nome);
      toast.success(`Gateway ativo agora é "${info.active}"`, 'Cobranças antigas seguem no gateway que as originou.');
      estado.reload();
    } catch (e) {
      toast.error('Falha ao trocar gateway', e instanceof Error ? e.message : undefined);
    } finally {
      setTrocando(null);
    }
  };

  const info = estado.data;

  return (
    <>
      <PageHeader title="Gateway PIX" desc="Qual gateway recebe as cobranças novas." />

      {estado.loading && !info && <Card><Loading /></Card>}
      {estado.error && <ErrorBlock message={estado.error} />}

      {info && (
        <>
          <div className="notice notice--info" style={{ maxWidth: 720 }}>
            Trocar o gateway só afeta cobranças <strong>novas</strong>. As já criadas continuam baixando no
            gateway que as originou.
          </div>

          <div className="grid grid--2">
            {info.available.map((nome) => {
              const ativo = nome === info.active;
              const ehDefault = nome === info.default;
              return (
                <Card key={nome} className="card--raise">
                  <div className="card__body">
                    <div className="row row--between" style={{ marginBottom: '0.75rem' }}>
                      <span className="row" style={{ gap: '0.6ch' }}>
                        <IconGateway size={18} />
                        <span className="td--strong" style={{ fontSize: '1.05rem', textTransform: 'capitalize' }}>{nome}</span>
                      </span>
                      {ativo ? (
                        <Badge tone="ok" dot>ativo</Badge>
                      ) : ehDefault ? (
                        <Badge tone="info">padrão do ambiente</Badge>
                      ) : (
                        <Badge tone="neutral">disponível</Badge>
                      )}
                    </div>
                    {ativo ? (
                      <p className="muted row" style={{ gap: '0.5ch' }}>
                        <IconCheck size={16} /> Recebendo as cobranças novas.
                      </p>
                    ) : admin ? (
                      <Button variant="primary" onClick={() => void trocar(nome)} loading={trocando === nome}>
                        Usar {nome}
                      </Button>
                    ) : (
                      <p className="faint">Só um administrador troca o gateway ativo.</p>
                    )}
                  </div>
                </Card>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}
